import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function ShowBroadcast() {
  const { notifId } = useParams();
  const history = useHistory();
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  
  const [notif, setNotif] = useState([]);


  // CONTROLLER
  const fetchNotif = async (id) => {
    await baseAPI 
      .get(`/v1/notification/show/${id}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.notif;       
        setNotif(data[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  useEffect(() => {
    // if (user.role === ANGGOTA) {
      fetchNotif(notifId);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='/broadcastlist' style={{ color: '#333' }}>List Broadcast</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Show Broadcast</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div>
                <p style={{fontSize: 25, marginBottom: 0}}><b>{notif.title}</b></p>
                <p style={{marginBottom: 0}}>{moment(notif.created_at).format("DD/MM/yyyy HH:mm:ss")}</p>
                <p>dari: {notif.role_name}</p>
              </div>
              <div class="text-secondary">
                {notif.body}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default ShowBroadcast;